import React from "react";
import styled from "styled-components";

import StripeSvg from "./StripesUp.svg";

const Line = styled.div`
  height: ${props => props.width || 2}px;
  width: 100%;
  position: absolute;
  background-color: ${props => props.color};

  :hover {
    box-shadow: 0 0 2px 1px ${props => props.color};
  }
`;

const Handler = styled.div`
  width: ${props => parseInt(props.width, 10) + 8}px;
  height: ${props => parseInt(props.width, 10) + 8}px;
  border-radius: 5px;
  background-color: ${props => props.theme.mainDark};
  position: absolute;
  top: -4px;
  right: -50%;
  left: 50%;
  border: 1px solid ${props => props.color}

  :hover {
    background-color: ${props => props.color}
    box-shadow: 0 0 2px 1px ${props => props.color};
    border-color: ${props => props.theme.mainDark};
  }

  :hover:before {
    content: "";
    position: absolute;
    top: -${props => parseInt(props.width, 10) + 19}px;
    left: ${props => 2 % parseInt(props.width, 10) ? "0" : "-1"}px;
    width: 10px;
    height: 12px;
    background: url(${StripeSvg}) no-repeat;
  }

  :hover:after {
    content: "";
    position: absolute;
    top: ${props => parseInt(props.width, 10) + 14}px;
    left: ${props => 2 % parseInt(props.width, 10) ? "0" : "-1"}px;
    width: 10px;
    height: 12px;
    background: url(${StripeSvg}) no-repeat;
    transform: scaleY(-1);
  }
`;

export default class HorizontalLine extends React.Component {
  onMouseDown = (e) => {
    // Set some data for ChartEventHandlers to use
    e.target.isDragHandleDown = true;
    e.target.dragHandleHandler = this.props.onDragEnd;
  };

  shouldComponentUpdate(nextProps) {
    if (
      nextProps.color !== this.props.color ||
      nextProps.width !== this.props.width ||
      nextProps.locked !== this.props.locked ||
      nextProps.value !== this.props.value
    ) {
      return true;
    }

    return false;
  }

  render() {
    return (
      <Line
        color={this.props.color}
        width={this.props.width}
        style={{
          transform: `translateY(${this.props.value}px)`
        }}
      >
        {!this.props.locked && <Handler
          onMouseDown={this.onMouseDown}
          onTouchStart={this.onMouseDown}
          color={this.props.color}
          width={this.props.width}
        />}
      </Line>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/Chart/GraphicalTools/HorizontalLine.js